import { createAction, createAsyncAction } from 'typesafe-actions'
import { FullProject, Project, ProjectCloseData, ReservableResponse, ServerProject } from '../../../responses/projects'
import { Entity, ID, PayloadType, } from '../../../types/UtilityTypes'
import { flow } from 'fp-ts/es6/function'
import { departmentsTasks, projectLens } from '../../../utils/lenses'
import * as array from 'fp-ts/es6/Array'
import { createPaginatedAction } from '../../../utils/redux-utils'
import { ProjectFiltersState } from '../../pages/project-list-filters'

// export type ProjectEditState = EmptyState | CancelState<Project> | DeleteState<Project> | CloseState<Project> | SpecificState<Project>

export const departmentsProjects = flow(departmentsTasks, array.map(projectLens.get))

export const projectActions = {
    startCancel: createAction('@DATA_PROJECT/START_CANCEL')<Project>(),
    startDelete: createAction('@DATA_PROJECT/START_DELETE')<Project>(),
    startClose: createAction('@DATA_PROJECT/START_CLOSE')<Project>(),
    startBind: createAction('@DATA_PROJECT/START_BIND')<Project>(),
    cancelEdit: createAction('@DATA_PROJECT/CANCEL_EDIT')(),
    get: createAsyncAction(
        '@DATA_PROJECT/GET_REQUEST',
        '@DATA_PROJECT/GET_SUCCESS',
        '@DATA_PROJECT/GET_FAILURE',
    )<ID, FullProject, void>(),
    list: createPaginatedAction(
        '@DATA_PROJECT/LIST_INIT',
        '@DATA_PROJECT/LIST_MORE',
        '@DATA_PROJECT/LIST_SUCCESS',
        '@DATA_PROJECT/LIST_FAILURE',
    )<ProjectFiltersState, { offset: number, projects: ServerProject[], total: number }>(),
    archive: createPaginatedAction(
        '@DATA_PROJECT/ARCHIVE_INIT',
        '@DATA_PROJECT/ARCHIVE_MORE',
        '@DATA_PROJECT/ARCHIVE_SUCCESS',
        '@DATA_PROJECT/ARCHIVE_FAILURE',
    )<ProjectFiltersState, { offset: number, projects: ServerProject[], total: number }>(),
    create: createAsyncAction(
        '@DATA_PROJECT/CREATE_REQUEST',
        '@DATA_PROJECT/CREATE_SUCCESS',
        '@DATA_PROJECT/CREATE_FAILURE'
    )<Partial<ServerProject>, [ServerProject, PayloadType], void>(),
    update: createAsyncAction(
        '@DATA_PROJECT/UPDATE_REQUEST',
        '@DATA_PROJECT/UPDATE_SUCCESS',
        '@DATA_PROJECT/UPDATE_FAILURE',
    )<[Partial<ServerProject> & Entity, {redirect?: boolean}], [ServerProject, PayloadType], void>(),
    cancel: createAsyncAction(
        '@DATA_PROJECT/CANCEL_REQUEST',
        '@DATA_PROJECT/CANCEL_SUCCESS',
        '@DATA_PROJECT/CANCEL_FAILURE',
    )<undefined, ServerProject, void>(),
    close: createAsyncAction(
        '@DATA_PROJECT/CLOSE_REQUEST',
        '@DATA_PROJECT/CLOSE_SUCCESS',
        '@DATA_PROJECT/CLOSE_FAILURE',
    )<ProjectCloseData, FullProject, void>(),
    remove: createAsyncAction(
        '@DATA_PROJECT/REMOVE_REQUEST',
        '@DATA_PROJECT/REMOVE_SUCCESS',
        '@DATA_PROJECT/REMOVE_FAILURE',
    )<undefined, ID, void>(),
    createFinplan: createAsyncAction(
        '@DATA_PROJECT/CREATE_FINPLAN_REQUEST',
        '@DATA_PROJECT/CREATE_FINPLAN_SUCCESS',
        '@DATA_PROJECT/CREATE_FINPLAN_FAILURE',
    )<ID, ServerProject, void>(),
    reservable: createPaginatedAction(
        '@DATA_PROJECT/RESERVABLE_INIT',
        '@DATA_PROJECT/RESERVABLE_MORE',
        '@DATA_PROJECT/RESERVABLE_SUCCESS',
        '@DATA_PROJECT/RESERVABLE_FAILURE',
    )<undefined, ReservableResponse, number>(),
    checkSource: createAsyncAction(
        '@DATA_PROJECT/CHECK_SOURCE_REQUEST',
        '@DATA_PROJECT/CHECK_SOURCE_SUCCESS',
        '@DATA_PROJECT/CHECK_SOURCE_FAILURE',
    )<ID, ID, void>(),
}
